/* eslint-disable consistent-return */

import { isEmpty } from 'lodash';
import { Module } from '../interfaces/Config';
import getFieldConfig from './getFieldConfig';

// this function returns a section of the json configuration given by a path / id...
const getConfigSection = (config, id) => {
  let objFound = null;

  const findId = (_config, _id) => {
    if (!_config) {
      return {};
    }

    if (!objFound) {
      if (_config.id && _config.id === _id) {
        objFound = _config;
      }

      if (!objFound) {
        if (typeof _config === 'object') {
          const keys = Object.keys(_config);

          if (keys.length) {
            return keys.forEach((x) => {
              if (!objFound) {
                findId(_config[x], _id);
              }
            });
          }
        }
      }
    }
  };

  findId(config, id);

  return objFound;
};

export const getScenariosConfig = (parentNode: string, authorisedModules: Module[]) => {
  const sceConfig = getConfigSection(authorisedModules, parentNode);

  if (
    sceConfig &&
    !isEmpty(sceConfig) &&
    sceConfig.config &&
    !isEmpty(sceConfig.config) &&
    sceConfig.config.scenariosConfig &&
    !isEmpty(sceConfig.config.scenariosConfig)
  ) {
    return sceConfig.config.scenariosConfig;
  }

  return {};
};

/**
 * Returns true when the `mooring.dynamic` field is available for use —
 * i.e. it is NOT configured with both `visible: false` and `default: false`.
 */
export const isDynamicFieldAvailable = (appConfig: any): boolean => {
  const { config: { dataConfig } } = getConfigSection(appConfig, 'ScenarioEditor');
  const fc = getFieldConfig('mooring.dynamic', dataConfig);
  return !(fc?.visible === false && fc?.default === false);
};

/**
 * Determines if a scenario should be considered "dynamic".
 *
 * Checks mooring.dynamic first, then falls back to ETAB/ETDB presence
 * for auto-generated scenarios where mooring.dynamic may not be set.
 */
export const isScenarioDynamic = (
  data: { mooring?: { startTime?: string; endTime?: string; dynamic?: boolean }; autoGeneratedEvent?: boolean } | undefined,
): boolean =>
  Boolean(data?.mooring?.dynamic || (data?.autoGeneratedEvent && data?.mooring?.startTime && data?.mooring?.endTime));

export default getConfigSection;
